"use client";

import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';

export default function BookingStep1() {
  const [form, setForm] = useState({
    pickupAddress: '',
    dropoffAddress: '',
    startDate: '',
    endDate: '',
    passengers: 1,
  });

  // const navigate = useNavigate();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleChange = (e: any) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleNext = () => {
    localStorage.setItem('bookingStep1', JSON.stringify(form));
    // navigate('/booking/step2');
  };

  return (
    <div className="max-w-xl mx-auto mt-10 bg-white p-6 shadow rounded-lg">
      <h2 className="text-2xl font-bold mb-6 text-center">Réserver une voiture avec chauffeur</h2>

      <div className="space-y-4">
        <div>
          <label className="block font-medium mb-1">Adresse de départ</label>
          <input
            type="text"
            name="pickupAddress"
            value={form.pickupAddress}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring focus:border-blue-500"
            placeholder="Ex: Aéroport SSR"
          />
        </div>

        <div>
          <label className="block font-medium mb-1">Adresse d&apos;arrivée</label>
          <input
            type="text"
            name="dropoffAddress"
            value={form.dropoffAddress}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring focus:border-blue-500"
            placeholder="Ex: Grand Baie"
          />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label className="block font-medium mb-1">Date et heure de début</label>
            <input
              type="datetime-local"
              name="startDate"
              value={form.startDate}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring focus:border-blue-500"
            />
          </div>

          <div>
            <label className="block font-medium mb-1">Date et heure de fin</label>
            <input
              type="datetime-local"
              name="endDate"
              value={form.endDate}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring focus:border-blue-500"
            />
          </div>
        </div>

        <div>
          <label className="block font-medium mb-1">Nombre de passagers</label>
          <input
            type="number"
            name="passengers"
            min={1}
            value={form.passengers}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring focus:border-blue-500"
          />
        </div>

        <button
          onClick={handleNext}
          className="w-full mt-4 bg-black text-white font-semibold py-3 rounded hover:bg-gray-800 transition"
        >
          Continuer
        </button>
      </div>
    </div>
  );
}
